import create from 'zustand';
import { storeWithModal } from './storeStates';

const rowKey = 'agreementRevisionId';
export const useRevisionsStore = create(set => storeWithModal(set, rowKey));
